import React from 'react'
import dynamic from 'next/dynamic'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { InsightPage } from 'src/components/insights/page'
import { Telescope } from '@emotion-icons/ionicons-sharp/Telescope'
import { FullScreenLoading } from 'src/components/full-screen-loading'

const UnavailableContent = dynamic(() => import('src/components/insights/unavailable/content'), {
  loading: () => <FullScreenLoading />,
  ssr: false,
})

const UnavailablePage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props

  return (
    <InsightPage>
      <React.Suspense fallback={<FullScreenLoading />}>
        <UnavailableContent insight={insight} />
      </React.Suspense>
    </InsightPage>
  )
}

export const Unavailable: Insight = {
  id: 'unavailable',
  component: UnavailablePage,
  name: 'Unavailable',
  icon: Telescope,
  supportedResultTypes: ['alphamap-location'],
  linkTooltipFile: 'unavailable-insight',
}
